import { mapAtom } from '../../atoms/map/map'
import { findLayer } from '../utils/findLayer'

export const clearPlaceFeatures = () => {
  const map = mapAtom.map
  const layer = findLayer(map, 'place')

  layer.getSource()?.clear()
}
